import * as React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { PulseLoader } from 'react-spinners';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export interface ITermsOfUsePDFProps {
    file: File | string;
    isFromUrl?: boolean;
}

export interface ITermsOfUsePDFState {
    numPages: any;
    pageNumber: number;
}

export class TermsOfUsePDF extends React.PureComponent<ITermsOfUsePDFProps, ITermsOfUsePDFState> {
    public fileInput;
    constructor(props: ITermsOfUsePDFProps) {
        super(props);
        this.state = {
            numPages: null,
            pageNumber: 1
        }
    }

    public onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    public render() {
        const { numPages } = this.state;
        const { file, isFromUrl } = this.props;
        return (
            <Document
                file={isFromUrl ? { url: file } : file}
                onLoadSuccess={this.onDocumentLoadSuccess}
                loading={<PulseLoader
                    size={10}
                    color={"#393939"}
                    loading={true}
                />}
            >
                {Array.from(Array(this.state.numPages)).map((page, index) => (
                    <div key={index}>
                        <Page key={page} pageNumber={index + 1} />
                        <p>Page {index + 1} of {numPages}</p>
                        <hr />
                    </div>
                ))}
            </Document>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/Auth/TermsOfUse/TermsOfUsePDF.tsx